export const DMAT_SET_CHECKOUT = "DMAT_SET_CHECKOUT";
